import React from 'react';
import _ from 'lodash';
import Select from 'react-select';

import Hint from 'jbc-front/components/Hint';

import { getOptionLabel } from 'src/utils/Utils';
import { CheckboxFieldWithoutForm } from 'src/components';
import InvitationHint from 'src/features/EmployeeInvitations/components/InvitationHint';
import { withTranslation } from 'react-i18next';
import i18n from 'i18next';

import styles from './EditableField.scss';

class EditableField extends React.Component {
  state = {
    showHint: false
  };

  handleClick = () => {
    const { user, currentLoginUser, onChangeUserChecked } = this.props;
    if (user.email === currentLoginUser.email) {
      this.setState({
        ...this.state,
        showHint: true
      });
    } else {
      onChangeUserChecked(user.id);
    }
  };

  hideHint = () => {
    this.setState({
      ...this.state,
      showHint: false
    });
  };

  // スタッフコードのフィールドを取得する
  static getStaffCodeField(user) {
    if (user.hasEmployee) {
      return user.staffCode;
    }
    return (
      <div className={styles.noEmployee}>
        <span>{i18n.t('features.RoleUsers.components.EditableField.no_employee_information')}</span>
        <Hint
          text={
            <dl>
              <dd>{i18n.t('features.RoleUsers.components.EditableField.This_is_an_account_registered_from_Authority_management_setting_Account_invitation')}</dd>
              <dd>{i18n.t('features.RoleUsers.components.EditableField.To_tie_it_with_the_employee_information_please_delete_the_account_from_Authority_management_setting_Edit_first')}</dd>
              <dd>{i18n.t('features.RoleUsers.components.EditableField.After_that_register_your_account_again_from_Employee_List_Invite_Employee')}</dd>
            </dl>
          }
        />
      </div>
    );
  }

  // 権限フィールドのComponentを取得する
  static getRoleField(mode, user, roles, onChange, unSelectable) {
    if (mode === 'SHOW' || unSelectable === true) {
      return <div className={styles.show}>{getOptionLabel(user.clientRoleId)(roles)}</div>;
    }
    return (
      <Select
        value={user.clientRoleId}
        options={roles}
        onChange={newOption => onChange(user, newOption)}
        clearable={false}
      />
    );
  }

  render() {
    const { mode, user, roles, onChange, currentLoginUser, t } = this.props;
    const userRoles = user.hasEmployee ? roles : roles.filter(hash => ['管理者', '運用担当者'].includes(hash.label));
    const loginUser = user.email === currentLoginUser.email;
    return (
      <tr>
        {mode === 'EDIT' && (
          <td
            onClick={e => {
              e.stopPropagation();
              this.handleClick();
            }}
            className={_.get(user, 'checked') ? 'm-table-checkbox-on' : 'm-table-checkbox-off'}
            role="presentation"
          >
            {this.state.showHint && (
              <InvitationHint onClick={this.hideHint}>{t('features.RoleUsers.components.EditableField.cannot_change_ones_own_authority')}</InvitationHint>
            )}
            <CheckboxFieldWithoutForm checked={_.get(user, 'checked')} readOnly />
          </td>
        )}
        <td className="u-break-word">{user.email}</td>
        <td className="u-break-word">{EditableField.getStaffCodeField(user)}</td>
        <td className="u-break-word">{user.fullName}</td>
        <td>{EditableField.getRoleField(mode, user, userRoles, onChange, loginUser)}</td>
      </tr>
    );
  }
}
export default withTranslation()(EditableField);
